import React from "react";
import isEmpty from "../../../../../store/validation/is-Empty";

export const ViewHealthAndSanitation = (props) => {
  return (
    <React.Fragment>
      <div className="row mb-4">
        <div className="col-6">
          <h4 className="font_20_m mb-2">
            Health and Sanitation practices at the Entry Point
          </h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(
                  props.data?.selected_health_and_sanitization_entrypoint
                ).length <= 0
                ? "-"
                : !isEmpty(
                    props.data?.selected_health_and_sanitization_entrypoint
                  ) &&
                  props.data?.selected_health_and_sanitization_entrypoint.map(
                    (item, index) => {
                      if (index === 0) {
                        return item.title;
                      } else if (item) {
                        return ", " + item.title;
                      }
                    }
                  )
              : "-"}
          </p>
        </div>
        <div className="col-6">
          <h4 className="font_20_m mb-2">
            Health and Sanitation practices inside the Facility
          </h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(props.data?.selected_health_and_sanitization_facility)
                  .length <= 0
                ? "-"
                : !isEmpty(
                    props.data?.selected_health_and_sanitization_facility
                  ) &&
                  props.data?.selected_health_and_sanitization_facility.map(
                    (item, index) => {
                      if (index === 0) {
                        return item.title;
                      } else if (item) {
                        return ", " + item.title;
                      }
                    }
                  )
              : "-"}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-6">
          <h4 className="font_20_m mb-2">
            Health and Sanitation practices for Services and Handling process
          </h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(
                  props.data?.selected_health_and_sanitization_food_handling
                ).length <= 0
                ? "-"
                : !isEmpty(
                    props.data?.selected_health_and_sanitization_food_handling
                  ) &&
                  props.data?.selected_health_and_sanitization_food_handling.map(
                    (item, index) => {
                      if (index === 0) {
                        return item.title;
                      } else if (item) {
                        return ", " + item.title;
                      }
                    }
                  )
              : "-"}
          </p>
        </div>
        <div className="col-6">
          <h4 className="font_20_m mb-2">
            Do you follow any other Health and Sanitation practices?
          </h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(
                  props.data?.selected_health_and_sanitization_health_safety
                ).length <= 0
                ? "-"
                : !isEmpty(
                    props.data?.selected_health_and_sanitization_health_safety
                  ) &&
                  props.data?.selected_health_and_sanitization_health_safety.map(
                    (item, index) => {
                      if (index === 0) {
                        return item.title;
                      } else if (item) {
                        return ", " + item.title;
                      }
                    }
                  )
              : "-"}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-12">
          <h4 className="font_20_m mb-2">
            Do you follow any other Health and Sanitation practices?
          </h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(
                  props.data?.selected_health_and_sanitization_health_safety
                ).length <= 0
                ? "-"
                : !isEmpty(
                    props.data?.selected_health_and_sanitization_health_safety
                  ) &&
                  props.data?.selected_health_and_sanitization_health_safety.map(
                    (item, index) => {
                      if (index === 0) {
                        return item.title;
                      } else if (item) {
                        return ", " + item.title;
                      }
                    }
                  )
              : "-"}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-12">
          <h4 className="font_20_m mb-2">
            Facility maintained as per Health and Hygiene standards and any
            COVID-19 protocol
          </h4>
          <p className="font_18_r c_gray">
            Key Points That Your Customers Must Be Aware Of:
          </p>
          <br />
          <p className="font_18_r c_gray">
            {props?.data?.discription !== undefined &&
            props?.data?.discription !== null
              ? props?.data?.discription
              : "-"}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};
